import React from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

interface UpdatesBannerProps {
  updatesAvailable: boolean;
  onAcknowledge: () => void;
}

const UpdatesBanner: React.FC<UpdatesBannerProps> = ({
  updatesAvailable,
  onAcknowledge,
}) => {
  return (
    <Snackbar
      open={updatesAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        variant="filled"
        action={
          <Button
            color="inherit"
            size="small"
            startIcon={<RefreshIcon />}
            onClick={onAcknowledge}
          >
            Refresh
          </Button>
        }
        sx={{ width: '100%' }}
      >
        Updates available
      </Alert>
    </Snackbar>
  );
};

export default UpdatesBanner;
